import { get } from 'lodash';
export default function isExperimentEnabled(experiments, experiment, value) {
    if (!value) {
        value = 'true';
    }
    const values = Array.isArray(value) ? value : [value];
    return values.includes(get(experiments, experiment));
}
//# sourceMappingURL=is-experiment-enabled.js.map